export class SendPriceMatchProductInformation {
    id?: string;
    productNumber?: string;
    productDescription?: string;
}